<div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">Close</button>
</div>
<mat-card>
    

        
        <!-- <h6>Location View</h6>&nbsp;&nbsp; -->
        <h6>Emp: {{ local_data.EmpCode +'-'+local_data.Name  }}</h6>&nbsp;&nbsp;
        <h6>Date: {{local_data.att_date | date: 'dd/MM/yyyy'}} </h6>
   
  
    <mat-card-content>
        <div class="map-wrap">
            <div class="map" #map></div>
        </div>
    </mat-card-content>


</mat-card>